import _ from 'lodash';
import { createTheme } from '@material-ui/core/styles';

import flex from './FlexMixins';
import companyLogo from '../static/images/company-logo.png';
import companyLogoDark from '../static/images/company-logo-dark.png';
import productLogo from '../static/images/product-logo.svg';
import productLogoDark from '../static/images/product-logo-dark.svg';
import productLogoPrint from '../static/images/product-logo-print.svg';
import themes from '../static/themes.json';
import { exportPaletteType } from '../utilities/ColorUtilities';

const common = _.merge(
    {
        mixins: {
            flex,
        },
        shape: {
            borderRadius: 2,
        },
    },
    themes.common
);

const Themes = {
    light: createTheme(
        _.merge(
            {
                palette: {
                    type: 'light',
                    panel: {
                        main: '#ffffff',
                        contrastText: 'rgba(38, 38, 38, 1)',
                    },
                    ...exportPaletteType('light'),
                },
                companyLogo,
                productLogo,
                productLogoContrast: productLogoPrint,
            },
            themes.light,
            common
        )
    ),

    dark: createTheme(
        _.merge(
            {
                palette: {
                    type: 'dark',
                    panel: {
                        main: '#313131',
                        contrastText: '#EAEAEA',
                    },
                    ...exportPaletteType('dark'),
                },
                overrides: {
                    MuiButton: {
                        textPrimary: {
                            color: 'rgba(69, 151, 203)',
                        },
                    },
                },
                companyLogo: companyLogoDark,
                productLogo: productLogoDark,
                productLogoContrast: productLogo,
            },
            themes.dark,
            common
        )
    ),

    print: createTheme(
        _.merge(
            {
                palette: {
                    type: 'light',
                    ...exportPaletteType('light'),
                },
                companyLogo,
                productLogo: productLogoPrint,
                productLogoContrast: productLogoPrint,
            },
            themes.light,
            common,
            {
                palette: {
                    background: {
                        paper: '#fff',
                        default: '#fff',
                    },
                    text: {
                        primary: 'rgba(38, 38, 38, 1)',
                    },
                    divider: 'rgba(0, 0, 0, 0.5)',
                },
                shadows: _.range(25).map(() => 'none'),
            }
        )
    ),
};

export default Themes;
